import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import { Header } from '../seo';
import { mergeClasses } from '@/utils/style';
import throttle from 'lodash.throttle';
function SeoPageLayoutSection(t0) {
  const $ = _c(12);
  const {
    content,
    sectionId,
    title,
    i,
    onScroll
  } = t0;
  const sectionRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== onScroll) {
    t1 = () => {
      const handleScroll = () => {
        const contentEl = sectionRef.current;
        if (!contentEl) {
          return;
        }
        const {
          top,
          bottom
        } = contentEl.getBoundingClientRect();
        const isActive = top - 180 <= 0 && bottom >= 0;
        if (isActive) {
          onScroll(contentEl.id);
        }
        if (window.scrollY < 600) {
          onScroll("");
        }
      };
      const throttledListener = throttle(handleScroll, 200);
      window.addEventListener("scroll", throttledListener);
      return () => {
        throttledListener.cancel();
        window.removeEventListener("scroll", throttledListener);
      };
    };
    t2 = [onScroll];
    $[0] = onScroll;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = i === 0;
  let t4;
  if ($[3] !== t3) {
    t4 = mergeClasses("relative mt-16 w-full lg:mt-20", {
      "mt-0 lg:mt-0": t3
    });
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title) {
    t5 = title && <Header>{title}</Header>;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== content || $[8] !== sectionId || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4} id={sectionId} ref={sectionRef}>{t5}{content}</div>;
    $[7] = content;
    $[8] = sectionId;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default SeoPageLayoutSection;